import React from 'react'
import FuneralWorkflowContainer from '../../components/workflow/FuneralWorkflowContainer'

export default function CreateCasePage() {
  const handleWorkflowComplete = (caseData: any) => {
    console.log('Workflow completed:', caseData)
    // The workflow container handles navigation internally
  }

  return (
    <FuneralWorkflowContainer
      onComplete={handleWorkflowComplete}
      redirectTo="/cases"
    />
  )
}